import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "apps--sprite",
  "use": "apps--sprite-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"apps--sprite\"><path d=\"M22,28h6V22H22m0-3h6V13H22m-9-3h6V4H13m9,6h6V4H22M13,19h6V13H13M4,19h6V13H4M4,28h6V22H4m9,6h6V22H13M4,10h6V4H4Z\" transform=\"translate(-4 -4)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol